import React from "react";
import BasicDialog from "../../../Common/Dialog/BasicDialog";

const FormStartDialog = ({ onSave, onClose, open, type }) => {
    const onSubmit = () => {
        const params = {};
        onSave(params);
        onClose();
    };

    return (
        <BasicDialog
            title={`Start ${type} to appraisal`}
            content={`Once you have started the ${type} process,
            you will be required to complete the various sections.`}
            open={open}
            onClose={onClose}
            onSubmit={onSubmit}
            buttonLabel={"Start"}
        />
    );
};

export default FormStartDialog;
